import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "rounded bg-white p-3 mb-4" };
const _hoisted_2 = { class: "d-flex justify-content-end" };
const _hoisted_3 = ["onUpdate:modelValue"];
const _hoisted_4 = ["onUpdate:modelValue"];
const _hoisted_5 = { class: "d-flex flex-wrap" };
const _hoisted_6 = ["onClick"];
const _hoisted_7 = {
    class: "modal fade",
    id: "create",
    tabindex: "-1",
    "aria-labelledby": "createModalLabel",
    "aria-hidden": "true"
};
const _hoisted_8 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_9 = { class: "modal-content" };
const _hoisted_10 = { class: "modal-body" };
const _hoisted_11 = { class: "form-floating mb-3" };
const _hoisted_12 = { class: "form-floating" };
import { FilterMatchMode } from '@primevue/core/api';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, router, useForm } from '@inertiajs/vue3';
import { onMounted, ref } from 'vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { useConfirm } from 'primevue';
import axios from 'axios';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Index',
    props: {
        productTypes: {
            type: Array,
            default: () => []
        }
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage, showSuccessMessage } = responseMessages();
        let { formatDate } = formatters();
        const props = __props;
        const confirm = useConfirm();
        onMounted(() => {
        });
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const productTypes = ref(props.productTypes);
        const createForm = useForm({
            name: null,
            nameEn: null
        });
        function create() {
            createForm.transform((data) => ({
                name: data.name,
                name_en: data.nameEn
            })).submit('post', route('admin.productTypes.store'), {
                preserveScroll: true,
                onSuccess: page => {
                    createForm.reset();
                    window.location.reload();
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        const onCellEditComplete = (event) => {
            let { newData } = event;
            axios.post(route('admin.productTypes.update', newData.uuid), {
                name: newData.name,
                name_en: newData.nameEn
            }).then((response) => {
                productTypes.value = productTypes.value.map((productType) => {
                    if (productType.uuid === newData.uuid) {
                        productType.name = newData.name;
                        productType.nameEn = newData.nameEn;
                    }
                    return productType;
                });
                showSuccessMessage('Änderungen gespeichert');
            }).catch((error) => {
                showErrorMessage(error);
            });
        };
        function remove(productType) {
            confirm.require({
                message: 'Soll der Produkt-Typ wirklich gelöscht werden?',
                header: 'Produkt-Typ löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    router.delete(route('admin.productTypes.destroy', productType.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            window.location.reload();
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Produkt-Typen" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "fw-bold mb-3" }, "Produkt-Typen", -1)),
                        _createElementVNode("div", _hoisted_1, [
                            _cache[7] || (_cache[7] = _createElementVNode("button", {
                                class: "btn btn-secondary d-inline-flex align-items-center",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#create"
                            }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    class: "bi bi-plus-lg",
                                    viewBox: "0 0 16 16"
                                }, [
                                    _createElementVNode("path", {
                                        "fill-rule": "evenodd",
                                        d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                    })
                                ]),
                                _createElementVNode("span", { class: "ms-2" }, "Neuer Produkt-Typ")
                            ], -1)),
                            _createVNode(_unref(DataTable), {
                                class: "mb-4",
                                dataKey: "id",
                                value: productTypes.value,
                                stripedRows: "",
                                responsiveLayout: "scroll",
                                globalFilterFields: ['name', 'nameEn', 'createdAt', 'updatedAt'],
                                filters: tableFilter.value,
                                "onUpdate:filters": _cache[1] || (_cache[1] = ($event) => ((tableFilter).value = $event)),
                                paginator: true,
                                rows: 10,
                                paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                                rowsPerPageOptions: [10, 25, 50, 150],
                                currentPageReportTemplate: "{first} von {last} von insgesamt {totalRecords}",
                                editMode: "cell",
                                onCellEditComplete: onCellEditComplete
                            }, {
                                header: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((tableFilter.value['global'].value) = $event)),
                                            placeholder: "Suche",
                                            style: { "width": "250px" }
                                        }, null, 512), [
                                            [_vModelText, tableFilter.value['global'].value]
                                        ])
                                    ])
                                ]),
                                empty: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                        _createElementVNode("div", { class: "p-3" }, " Keine Einträge gefunden ", -1)
                                    ]))]),
                                loading: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                        _createTextVNode(" Einträge werden geladen ... ", -1)
                                    ]))]),
                                default: _withCtx(() => [
                                    _createVNode(_unref(Column), {
                                        header: "#",
                                        sortable: true
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Name",
                                        sortable: true,
                                        sortField: "name"
                                    }, {
                                        body: _withCtx(({ data }) => [
                                            _createTextVNode(_toDisplayString(data.name), 1)
                                        ]),
                                        editor: _withCtx(({ data }) => [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                "onUpdate:modelValue": ($event) => ((data.name) = $event),
                                                required: ""
                                            }, null, 8, _hoisted_3), [
                                                [_vModelText, data.name]
                                            ])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Name (En)",
                                        sortable: true,
                                        sortField: "nameEn"
                                    }, {
                                        body: _withCtx(({ data }) => [
                                            _createTextVNode(_toDisplayString(data.nameEn), 1)
                                        ]),
                                        editor: _withCtx(({ data }) => [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                "onUpdate:modelValue": ($event) => ((data.nameEn) = $event),
                                                required: ""
                                            }, null, 8, _hoisted_4), [
                                                [_vModelText, data.nameEn]
                                            ])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Letzte Änderung",
                                        sortable: true,
                                        sortField: "updatedAt"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.updatedAt, true)), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Erstellt",
                                        sortable: true,
                                        sortField: "createdAt"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.createdAt, true)), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), { header: "" }, {
                                        body: _withCtx((slotProps) => [
                                            _createElementVNode("div", _hoisted_5, [
                                                _createElementVNode("button", {
                                                    class: "btn",
                                                    onClick: ($event) => (remove(slotProps.data))
                                                }, [...(_cache[6] || (_cache[6] = [
                                                        _createElementVNode("svg", {
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            width: "16",
                                                            height: "16",
                                                            fill: "currentColor",
                                                            class: "bi bi-x-circle text-danger",
                                                            viewBox: "0 0 16 16"
                                                        }, [
                                                            _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                            _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                        ], -1)
                                                    ]))], 8, _hoisted_6)
                                            ])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["value", "filters"])
                        ])
                    ]),
                    _: 1
                }),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("h1", {
                                        class: "modal-title fs-5 fw-bold",
                                        id: "createModalLabel"
                                    }, "Neuer Produkt-Typ"),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    })
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(create, ["prevent"])
                                }, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _createElementVNode("div", _hoisted_11, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "name",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(createForm).name) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(createForm).name]
                                            ]),
                                            _cache[9] || (_cache[9] = _createElementVNode("label", { for: "name" }, "Name", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_12, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "nameEn",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(createForm).nameEn) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(createForm).nameEn]
                                            ]),
                                            _cache[10] || (_cache[10] = _createElementVNode("label", { for: "nameEn" }, "Name (En)", -1))
                                        ])
                                    ]),
                                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-secondary",
                                            "data-bs-dismiss": "modal"
                                        }, "Abbrechen"),
                                        _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ])
                                    ], -1))
                                ], 32)
                            ])
                        ])
                    ])
                ]))
            ], 64));
        };
    }
});
